import {
    EVENT_CINEMAS,
    HOYTS_CINEMAS,
    LUNA_CINEMAS,
    MOVING_STORY,
    ORANA_CINEMAS,
    PALACE_CINEMAS,
    READING_CINEMAS,
    VILLAGE_CINEMAS
} from "@config/config";
import EventLogo from "@components/CinemaGroupLogo/EventLogo";
import HoytsLogo from "@components/CinemaGroupLogo/HoytsLogo";
import LunaLogo from "@components/CinemaGroupLogo/LunaLogo";
import MovingStoryLogo from "@components/CinemaGroupLogo/MovingStoryLogo";
import OranaLogo from "@components/CinemaGroupLogo/OranaLogo";
import PalaceLogo from "@components/CinemaGroupLogo/PalaceLogo";
import ReadingsLogo from "@components/CinemaGroupLogo/ReadingsLogo";
import VillageLogo from "@components/CinemaGroupLogo/VillageLogo";

export default function getCinemaGroupLogo(id) {
    switch (id) {
        case HOYTS_CINEMAS: return HoytsLogo;
        case VILLAGE_CINEMAS: return VillageLogo;
        case EVENT_CINEMAS: return EventLogo;
        case LUNA_CINEMAS: return LunaLogo;
        case PALACE_CINEMAS: return PalaceLogo;
        case READING_CINEMAS: return ReadingsLogo;
        case ORANA_CINEMAS: return OranaLogo;
        case MOVING_STORY: return MovingStoryLogo;
        default: return () => null;
    }
}
